import React from 'react';
import UserRole from '../../shared/AuthRoles';
import { Chip, useTheme } from '@mui/material';
import { lighten } from '@mui/material/styles';

interface ChipProps {
    user: {
        role: string;
        viewOnly: boolean;
    };
}

/** Admin chip matches reservation list “Approved” status (yellow tint + outline). */
const RoleChip = ({ user }: ChipProps) => {
    const loggedInUser = UserRole();
    const theme = useTheme();

    const isAdmin =
        Boolean(user?.role?.includes('admin')) ||
        loggedInUser?.role === 'admin';

    return (
        <Chip
            size='small'
            sx={{
                flexShrink: 0,
                fontWeight: 600,
                '& .MuiChip-label': {
                    fontSize: '0.6875rem',
                    lineHeight: 1.2,
                    px: 0.75,
                },
                ...(isAdmin
                    ? {
                          bgcolor: lighten(theme.palette.yellow.main, 0.78),
                          color: theme.palette.yellow.main,
                          borderColor: lighten(theme.palette.yellow.main, 0.35),
                      }
                    : {
                          bgcolor: theme.palette.lightGrey.main,
                          color: theme.palette.lightGrey.contrastText,
                      }),
            }}
            label={
                user?.role === 'owner_admin' ||
                user?.role === 'guest_admin' ||
                user?.role === 'contractor_admin' ||
                loggedInUser?.role === 'admin'
                    ? 'Admin'
                    : user?.viewOnly === true
                      ? 'User (View only)'
                      : 'User'
            }
        />
    );
};

export default RoleChip;
